import { cn } from "@/shared/utils/cn";
import Icon from "../Icon/Icon";
import { rgba } from "@/shared/utils/color";
import { HTMLAttributes } from "react";
import { useIsRTL } from "@/shared/hooks/useRTL";

export interface ToggleProps {
  onClick?: () => void;
  active?: boolean;
  top?: string;
  display?: HTMLAttributes<HTMLDivElement>["style"]["display"];
  chevronDirection?: "up" | "down" | "left" | "right";
  right?: string;
  className?: string;
}

const Toggle = ({
  onClick,
  active,
  top = "5rem",
  chevronDirection = "right",
  className,
}: ToggleProps) => {
  const isRTL = useIsRTL();
  const direction = isRTL ? "left-[-1.25rem]" : "right-[-1.25rem]";
  const getDegrees = () => {
    if (chevronDirection === "up") {
      return `${active ? 0 : 180}deg`;
    } else if (chevronDirection === "down") {
      return `${active ? 180 : 0}deg`;
    } else if (chevronDirection === "left") {
      return `${active ? 90 : 270}deg`;
    } else {
      return `${active ? 270 : 90}deg`;
    }
  };

  return (
    <span
      onClick={onClick}
      className={cn(
        "absolute w-11 h-11 flex items-center justify-center bg-white rounded-full z-10 cursor-pointer",
        direction,
        className,
      )}
      style={{
        ...({ top: top} as any),
        boxShadow: `0 0 1rem 0.5rem ${rgba("#000000", 0.075)}`,
      }}
    >
      <Icon
        style={{
          transform: `rotate(${getDegrees()})`,
        }}
        variants="chevron"
        className="size-5 fill-primary transition-all duration-250"
      />
    </span>
  );
};

export default Toggle;
